import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-08fe97dc")
const _hoisted_1 = {
  id: "kt_content_container scrollspy-container",
  class: "container-xxl py-0 support-view",
  "data-bs-spy": "scroll",
  "data-bs-target": "#support-tool-navbar",
  "data-bs-offset": "1",
  "data-bs-method": "offset"
}
const _hoisted_2 = { class: "nav-container" }
const _hoisted_3 = { class: "card overflow-hidden" }
const _hoisted_4 = { class: "card-body nav nav-pills flex-column p-3" }
const _hoisted_5 = {
  id: "support-tool-navbar",
  class: "navbar navbar-light bg-white flex-column align-items-stretch p-0"
}
const _hoisted_6 = { class: "nav nav-pills flex-column" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("a", {
  class: "nav-link fs-5 fw-bolder mt-2",
  href: "#search"
}, "Search", -1)
const _hoisted_8 = { class: "nav nav-pills flex-column mb-2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("a", {
  class: "nav-link sub-nav-link ms-3 mt-1 fs-6 fw-bold",
  href: "#search-queries"
}, "Queries", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("a", {
  class: "nav-link sub-nav-link ms-3 mt-1 fs-6 fw-bold",
  href: "#search-params"
}, "Params", -1)
const _hoisted_11 = {
  key: 0,
  class: "nav-link sub-nav-link ms-3 mt-1 fs-6 fw-bold",
  href: "#search-errors"
}
const _hoisted_12 = {
  key: 0,
  class: "nav-link fs-5 fw-bolder my-2",
  href: "#account"
}
const _hoisted_13 = {
  key: 1,
  class: "nav nav-pills flex-column mb-2"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("a", {
  class: "nav-link sub-nav-link ms-3 mt-1 fs-6 fw-bold",
  href: "#account-info"
}, "Info", -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = {
  key: 2,
  class: "nav-link fs-5 fw-bolder my-2",
  href: "#integrations"
}
const _hoisted_17 = {
  key: 3,
  class: "nav nav-pills flex-column mb-2"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("a", {
  class: "nav-link sub-nav-link ms-3 mt-1 fs-6 fw-bold",
  href: "#integrations-info"
}, "Info", -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = {
  key: 4,
  class: "nav-link fs-5 fw-bolder my-2",
  href: "#product"
}
const _hoisted_21 = {
  key: 5,
  class: "nav nav-pills flex-column mb-2"
}
const _hoisted_22 = {
  key: 0,
  class: "nav-link sub-nav-link ms-3 mt-1 fs-6 fw-bold",
  href: "#product-info"
}
const _hoisted_23 = {
  key: 1,
  class: "nav-link sub-nav-link ms-3 mt-1 fs-6 fw-bold",
  href: "#product-import-log"
}
const _hoisted_24 = {
  key: 6,
  class: "nav-link fs-5 fw-bolder my-2",
  href: "#order"
}
const _hoisted_25 = { class: "nav nav-pills flex-column mb-2" }
const _hoisted_26 = {
  key: 0,
  class: "nav-link sub-nav-link ms-3 mt-1 fs-6 fw-bold",
  href: "#order-info"
}
const _hoisted_27 = {
  key: 1,
  class: "nav-link sub-nav-link ms-3 mt-1 fs-6 fw-bold",
  href: "#order-items"
}
const _hoisted_28 = {
  key: 7,
  class: "nav-link fs-5 fw-bolder my-2",
  href: "#bundles"
}
const _hoisted_29 = {
  key: 8,
  class: "nav nav-pills flex-column mb-2"
}
const _hoisted_30 = {
  key: 0,
  class: "nav-link sub-nav-link ms-3 mt-1 fs-6 fw-bold",
  href: "#bundles-bundle-components"
}
const _hoisted_31 = {
  key: 1,
  class: "nav-link sub-nav-link ms-3 mt-1 fs-6 fw-bold",
  href: "#bundles-components-bundles"
}
const _hoisted_32 = {
  key: 9,
  class: "nav-link fs-5 fw-bolder my-2",
  href: "#events"
}
const _hoisted_33 = {
  key: 10,
  class: "nav nav-pills flex-column mb-2"
}
const _hoisted_34 = {
  key: 0,
  class: "nav-link sub-nav-link ms-3 mt-1 fs-6 fw-bold",
  href: "#events-notifications"
}
const _hoisted_35 = {
  key: 1,
  class: "nav-link sub-nav-link ms-3 mt-1 fs-6 fw-bold",
  href: "#events-stock-log"
}
const _hoisted_36 = { class: "main-container d-flex flex-column position-relative" }
const _hoisted_37 = {
  class: "mo-gap",
  id: "search"
}
const _hoisted_38 = { class: "card" }
const _hoisted_39 = { class: "card-header" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", { class: "card-title fs-3 fw-bolder m-0" }, " Search ", -1)
const _hoisted_41 = { class: "card-toolbar d-flex gap-2" }
const _hoisted_42 = {
  key: 0,
  class: "spinner-border spinner-border-sm text-light position-absolute",
  role: "status"
}
const _hoisted_43 = {
  key: 0,
  class: "spinner-border spinner-border-sm text-light position-absolute",
  role: "status"
}
const _hoisted_44 = {
  key: 0,
  class: "spinner-border spinner-border-sm text-light position-absolute",
  role: "status"
}
const _hoisted_45 = { class: "card-body d-flex flex-column p-0" }
const _hoisted_46 = {
  class: "w-100 pb-4 pt-6 px-10 border-bottom",
  id: "search-queries"
}
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", { class: "fs-5 fw-bold m-0 mb-6 mx-n2" }, "Queries", -1)
const _hoisted_48 = { class: "d-flex flex-column gap-4 mb-4 mx-2" }
const _hoisted_49 = { class: "data-container rounded flex-wrap" }
const _hoisted_50 = { class: "d-flex flex-column align-items-stretch" }
const _hoisted_51 = { class: "info-item-shadow mo-list-group-item d-flex form-check form-switch metronic-dropdown-item menu-link fs-6 metronic-dropdown-text align-items-center" }
const _hoisted_52 = { class: "info-item-shadow mo-list-group-item d-flex form-check form-switch metronic-dropdown-item menu-link fs-6 metronic-dropdown-text align-items-center" }
const _hoisted_53 = { class: "d-flex flex-column align-items-stretch" }
const _hoisted_54 = { class: "info-item-shadow mo-list-group-item d-flex form-check form-switch metronic-dropdown-item menu-link fs-6 metronic-dropdown-text align-items-center" }
const _hoisted_55 = { class: "info-item-shadow mo-list-group-item d-flex form-check form-switch metronic-dropdown-item menu-link fs-6 metronic-dropdown-text align-items-center" }
const _hoisted_56 = { class: "d-flex flex-column align-items-stretch" }
const _hoisted_57 = { class: "info-item-shadow mo-list-group-item d-flex form-check form-switch metronic-dropdown-item menu-link fs-6 metronic-dropdown-text align-items-center" }
const _hoisted_58 = { class: "info-item-shadow mo-list-group-item d-flex form-check form-switch metronic-dropdown-item menu-link fs-6 metronic-dropdown-text align-items-center" }
const _hoisted_59 = { class: "d-flex flex-column align-items-stretch" }
const _hoisted_60 = { class: "info-item-shadow mo-list-group-item d-flex form-check form-switch metronic-dropdown-item menu-link fs-6 metronic-dropdown-text align-items-center" }
const _hoisted_61 = { class: "info-item-shadow mo-list-group-item d-flex form-check form-switch metronic-dropdown-item menu-link fs-6 metronic-dropdown-text align-items-center" }
const _hoisted_62 = { class: "d-flex flex-column align-items-stretch" }
const _hoisted_63 = { class: "info-item-shadow mo-list-group-item d-flex form-check form-switch metronic-dropdown-item menu-link fs-6 metronic-dropdown-text align-items-center" }
const _hoisted_64 = { class: "info-item-shadow mo-list-group-item d-flex form-check form-switch metronic-dropdown-item menu-link fs-6 metronic-dropdown-text align-items-center" }
const _hoisted_65 = {
  class: "w-100 pb-4 pt-6 px-10 border-bottom",
  id: "search-params"
}
const _hoisted_66 = /*#__PURE__*/_createElementVNode("div", { class: "fs-5 fw-bold m-0 mb-6 mx-n2" }, "Params", -1)
const _hoisted_67 = { class: "d-flex flex-column gap-4 mb-4 mx-2" }
const _hoisted_68 = {
  key: 0,
  class: "fw-bold m-1 text-danger bg-light p-2 rounded"
}
const _hoisted_69 = {
  key: 1,
  class: "form-floating info-item-shadow-2x rounded"
}
const _hoisted_70 = {
  key: 2,
  class: "form-floating info-item-shadow-2x rounded"
}
const _hoisted_71 = {
  key: 3,
  class: "form-floating info-item-shadow-2x rounded overflow-hidden"
}
const _hoisted_72 = /*#__PURE__*/_createElementVNode("label", { for: "fiSiteId" }, "Site ID", -1)
const _hoisted_73 = {
  key: 4,
  class: "form-floating info-item-shadow-2x"
}
const _hoisted_74 = /*#__PURE__*/_createElementVNode("label", { for: "fiMarketplaceId" }, "Marketplace ID", -1)
const _hoisted_75 = {
  key: 5,
  class: "form-floating info-item-shadow-2x"
}
const _hoisted_76 = /*#__PURE__*/_createElementVNode("label", { for: "fiSysProdId" }, "System Product ID", -1)
const _hoisted_77 = {
  key: 6,
  class: "form-floating info-item-shadow-2x"
}
const _hoisted_78 = /*#__PURE__*/_createElementVNode("label", { for: "fiMarkProdId" }, "Marketplace Product ID", -1)
const _hoisted_79 = {
  key: 7,
  class: "form-floating info-item-shadow-2x"
}
const _hoisted_80 = /*#__PURE__*/_createElementVNode("label", { for: "fiProdSku" }, "Product SKU", -1)
const _hoisted_81 = {
  key: 8,
  class: "form-floating info-item-shadow-2x"
}
const _hoisted_82 = /*#__PURE__*/_createElementVNode("label", { for: "fiOrderNum" }, "Order Number", -1)
const _hoisted_83 = {
  key: 9,
  class: "form-floating info-item-shadow-2x"
}
const _hoisted_84 = /*#__PURE__*/_createElementVNode("label", { for: "fiOrderId" }, "Order ID", -1)
const _hoisted_85 = {
  key: 10,
  class: "form-floating info-item-shadow-2x"
}
const _hoisted_86 = /*#__PURE__*/_createElementVNode("label", { for: "fiSearchKeyword" }, "Search Keyword", -1)
const _hoisted_87 = {
  key: 0,
  class: "w-100 pb-4 pt-6 px-10",
  id: "search-errors"
}
const _hoisted_88 = /*#__PURE__*/_createElementVNode("div", { class: "fs-5 fw-bold m-0 mb-6 mx-n2" }, "Errors", -1)
const _hoisted_89 = { class: "d-flex flex-column gap-4 mb-4 mx-2" }
const _hoisted_90 = {
  key: 0,
  class: "mo-gap",
  id: "account"
}
const _hoisted_91 = { class: "card" }
const _hoisted_92 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title fw-bold m-0" }, " Account ")
], -1)
const _hoisted_93 = { class: "card-body d-flex flex-column p-0" }
const _hoisted_94 = {
  class: "w-100 pb-4 pt-6 px-10",
  id: "account-info"
}
const _hoisted_95 = /*#__PURE__*/_createElementVNode("div", { class: "fs-5 fw-bold m-0 mb-6 mx-n2" }, "Info", -1)
const _hoisted_96 = { class: "d-flex flex-column gap-4 mb-4 mx-2" }
const _hoisted_97 = {
  key: 1,
  class: "mo-gap",
  id: "integrations"
}
const _hoisted_98 = { class: "card" }
const _hoisted_99 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title fw-bold m-0" }, " Integrations ")
], -1)
const _hoisted_100 = { class: "card-body d-flex flex-column p-0" }
const _hoisted_101 = {
  class: "w-100 pb-4 pt-6 px-10",
  id: "integrations-info"
}
const _hoisted_102 = /*#__PURE__*/_createElementVNode("div", { class: "fs-5 fw-bold m-0 mb-6 mx-n2" }, "Info", -1)
const _hoisted_103 = { class: "d-flex flex-column gap-4 mb-4 mx-2" }
const _hoisted_104 = {
  key: 2,
  class: "mo-gap",
  id: "product"
}
const _hoisted_105 = { class: "card" }
const _hoisted_106 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title fw-bold m-0" }, " Product ")
], -1)
const _hoisted_107 = { class: "card-body d-flex flex-column p-0" }
const _hoisted_108 = {
  key: 0,
  class: "w-100 pb-4 pt-6 px-10",
  id: "product-info"
}
const _hoisted_109 = /*#__PURE__*/_createElementVNode("div", { class: "fs-5 fw-bold m-0 mb-6 mx-n2" }, "Info", -1)
const _hoisted_110 = { class: "d-flex flex-column gap-4 mb-4 mx-2" }
const _hoisted_111 = { class: "w-100 d-flex justify-content-end align-items-center" }
const _hoisted_112 = { class: "pagination" }
const _hoisted_113 = { class: "page-item previous" }
const _hoisted_114 = /*#__PURE__*/_createElementVNode("i", { class: "previous" }, null, -1)
const _hoisted_115 = [
  _hoisted_114
]
const _hoisted_116 = { class: "page-item active" }
const _hoisted_117 = { class: "page-link bg-blue" }
const _hoisted_118 = { class: "page-item next" }
const _hoisted_119 = /*#__PURE__*/_createElementVNode("i", { class: "next" }, null, -1)
const _hoisted_120 = [
  _hoisted_119
]
const _hoisted_121 = {
  key: 1,
  class: "w-100 pb-4 pt-6 px-10",
  id: "product-import-log"
}
const _hoisted_122 = /*#__PURE__*/_createElementVNode("div", { class: "fs-5 fw-bold m-0 mb-6 mx-n2" }, "Import Logs", -1)
const _hoisted_123 = { class: "d-flex flex-column gap-4 mb-4 mx-2" }
const _hoisted_124 = { class: "w-100 d-flex justify-content-end align-items-center" }
const _hoisted_125 = { class: "pagination" }
const _hoisted_126 = { class: "page-item previous" }
const _hoisted_127 = /*#__PURE__*/_createElementVNode("i", { class: "previous" }, null, -1)
const _hoisted_128 = [
  _hoisted_127
]
const _hoisted_129 = { class: "page-item active" }
const _hoisted_130 = { class: "page-link bg-blue" }
const _hoisted_131 = { class: "page-item next" }
const _hoisted_132 = /*#__PURE__*/_createElementVNode("i", { class: "next" }, null, -1)
const _hoisted_133 = [
  _hoisted_132
]
const _hoisted_134 = {
  key: 3,
  class: "mo-gap",
  id: "order"
}
const _hoisted_135 = { class: "card" }
const _hoisted_136 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title fw-bold m-0" }, " Order ")
], -1)
const _hoisted_137 = { class: "card-body d-flex flex-column px-0" }
const _hoisted_138 = {
  key: 0,
  class: "w-100 pb-10 pt-5 px-10",
  id: "order-info"
}
const _hoisted_139 = /*#__PURE__*/_createElementVNode("div", { class: "fs-5 fw-bold m-0 mb-6 mx-n2" }, "Info / Shipments", -1)
const _hoisted_140 = { class: "d-flex flex-column gap-4 mb-4 mx-2" }
const _hoisted_141 = { class: "w-100 d-flex justify-content-end align-items-center" }
const _hoisted_142 = { class: "pagination" }
const _hoisted_143 = { class: "page-item previous" }
const _hoisted_144 = /*#__PURE__*/_createElementVNode("i", { class: "previous" }, null, -1)
const _hoisted_145 = [
  _hoisted_144
]
const _hoisted_146 = { class: "page-item active" }
const _hoisted_147 = { class: "page-link bg-blue" }
const _hoisted_148 = { class: "page-item next" }
const _hoisted_149 = /*#__PURE__*/_createElementVNode("i", { class: "next" }, null, -1)
const _hoisted_150 = [
  _hoisted_149
]
const _hoisted_151 = {
  key: 1,
  class: "w-100 pb-10 pt-5 px-10",
  id: "order-items"
}
const _hoisted_152 = /*#__PURE__*/_createElementVNode("div", { class: "fs-5 fw-bold m-0 mb-6 mx-n2" }, "Items", -1)
const _hoisted_153 = { class: "d-flex flex-column gap-4 mb-4 mx-2" }
const _hoisted_154 = { class: "w-100 d-flex justify-content-end align-items-center" }
const _hoisted_155 = { class: "pagination" }
const _hoisted_156 = { class: "page-item previous" }
const _hoisted_157 = /*#__PURE__*/_createElementVNode("i", { class: "previous" }, null, -1)
const _hoisted_158 = [
  _hoisted_157
]
const _hoisted_159 = { class: "page-item active" }
const _hoisted_160 = { class: "page-link bg-blue" }
const _hoisted_161 = { class: "page-item next" }
const _hoisted_162 = /*#__PURE__*/_createElementVNode("i", { class: "next" }, null, -1)
const _hoisted_163 = [
  _hoisted_162
]
const _hoisted_164 = {
  key: 4,
  class: "mo-gap",
  id: "bundles"
}
const _hoisted_165 = { class: "card" }
const _hoisted_166 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title fw-bold m-0" }, " Bundles ")
], -1)
const _hoisted_167 = { class: "card-body d-flex flex-column px-0" }
const _hoisted_168 = {
  key: 0,
  class: "w-100 pb-10 pt-5 px-10",
  id: "bundles-bundle-components"
}
const _hoisted_169 = /*#__PURE__*/_createElementVNode("div", { class: "fs-5 fw-bold m-0 mb-6 mx-n2" }, "Bundle Components", -1)
const _hoisted_170 = { class: "d-flex flex-column gap-4 mb-4 mx-2" }
const _hoisted_171 = { class: "w-100 d-flex justify-content-end align-items-center" }
const _hoisted_172 = { class: "pagination" }
const _hoisted_173 = { class: "page-item previous" }
const _hoisted_174 = /*#__PURE__*/_createElementVNode("i", { class: "previous" }, null, -1)
const _hoisted_175 = [
  _hoisted_174
]
const _hoisted_176 = { class: "page-item active" }
const _hoisted_177 = { class: "page-link bg-blue" }
const _hoisted_178 = { class: "page-item next" }
const _hoisted_179 = /*#__PURE__*/_createElementVNode("i", { class: "next" }, null, -1)
const _hoisted_180 = [
  _hoisted_179
]
const _hoisted_181 = {
  key: 1,
  class: "w-100 pb-10 pt-5 px-10",
  id: "bundles-components-bundles"
}
const _hoisted_182 = /*#__PURE__*/_createElementVNode("div", { class: "fs-5 fw-bold m-0 mb-6 mx-n2" }, "Components Bundles", -1)
const _hoisted_183 = { class: "d-flex flex-column gap-4 mb-4 mx-2" }
const _hoisted_184 = { class: "w-100 d-flex justify-content-end align-items-center" }
const _hoisted_185 = { class: "pagination" }
const _hoisted_186 = { class: "page-item previous" }
const _hoisted_187 = /*#__PURE__*/_createElementVNode("i", { class: "previous" }, null, -1)
const _hoisted_188 = [
  _hoisted_187
]
const _hoisted_189 = { class: "page-item active" }
const _hoisted_190 = { class: "page-link bg-blue" }
const _hoisted_191 = { class: "page-item next" }
const _hoisted_192 = /*#__PURE__*/_createElementVNode("i", { class: "next" }, null, -1)
const _hoisted_193 = [
  _hoisted_192
]
const _hoisted_194 = {
  key: 5,
  class: "mo-gap",
  id: "events"
}
const _hoisted_195 = { class: "card" }
const _hoisted_196 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title fw-bold m-0" }, " Events ")
], -1)
const _hoisted_197 = { class: "card-body d-flex flex-column px-0" }
const _hoisted_198 = {
  key: 0,
  class: "w-100 pb-10 pt-5 px-10",
  id: "events-notifications"
}
const _hoisted_199 = /*#__PURE__*/_createElementVNode("div", { class: "fs-5 fw-bold m-0 mb-6 mx-n2" }, "Notifications", -1)
const _hoisted_200 = { class: "d-flex flex-column gap-4 mb-4 mx-2" }
const _hoisted_201 = { class: "w-100 d-flex justify-content-end align-items-center" }
const _hoisted_202 = { class: "pagination" }
const _hoisted_203 = { class: "page-item previous" }
const _hoisted_204 = /*#__PURE__*/_createElementVNode("i", { class: "previous" }, null, -1)
const _hoisted_205 = [
  _hoisted_204
]
const _hoisted_206 = { class: "page-item active" }
const _hoisted_207 = { class: "page-link bg-blue" }
const _hoisted_208 = { class: "page-item next" }
const _hoisted_209 = /*#__PURE__*/_createElementVNode("i", { class: "next" }, null, -1)
const _hoisted_210 = [
  _hoisted_209
]
const _hoisted_211 = {
  key: 1,
  class: "w-100 pb-10 pt-5 px-10",
  id: "events-stock-log"
}
const _hoisted_212 = /*#__PURE__*/_createElementVNode("div", { class: "fs-5 fw-bold m-0 mb-6 mx-n2" }, "Stock Log", -1)
const _hoisted_213 = { class: "d-flex flex-column gap-4 mb-4 mx-2" }
const _hoisted_214 = { class: "w-100 d-flex justify-content-end align-items-center" }
const _hoisted_215 = { class: "pagination" }
const _hoisted_216 = { class: "page-item previous" }
const _hoisted_217 = /*#__PURE__*/_createElementVNode("i", { class: "previous" }, null, -1)
const _hoisted_218 = [
  _hoisted_217
]
const _hoisted_219 = { class: "page-item active" }
const _hoisted_220 = { class: "page-link bg-blue" }
const _hoisted_221 = { class: "page-item next" }
const _hoisted_222 = /*#__PURE__*/_createElementVNode("i", { class: "next" }, null, -1)
const _hoisted_223 = [
  _hoisted_222
]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Datepicker = _resolveComponent("Datepicker")!
  const _component_SupportToolTable = _resolveComponent("SupportToolTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("nav", _hoisted_5, [
            _createElementVNode("nav", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("nav", _hoisted_8, [
                _hoisted_9,
                _hoisted_10,
                (_ctx.queryErrors.length !== 0)
                  ? (_openBlock(), _createElementBlock("a", _hoisted_11, "Errors"))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.loadedData.accountData)
                ? (_openBlock(), _createElementBlock("a", _hoisted_12, "Account"))
                : _createCommentVNode("", true),
              (_ctx.loadedData.accountData)
                ? (_openBlock(), _createElementBlock("nav", _hoisted_13, _hoisted_15))
                : _createCommentVNode("", true),
              (_ctx.loadedData.integrationsData)
                ? (_openBlock(), _createElementBlock("a", _hoisted_16, "Integrations"))
                : _createCommentVNode("", true),
              (_ctx.loadedData.integrationsData)
                ? (_openBlock(), _createElementBlock("nav", _hoisted_17, _hoisted_19))
                : _createCommentVNode("", true),
              (_ctx.loadedData.productData || _ctx.loadedData.productImportLogs)
                ? (_openBlock(), _createElementBlock("a", _hoisted_20, "Product"))
                : _createCommentVNode("", true),
              (_ctx.loadedData.productData)
                ? (_openBlock(), _createElementBlock("nav", _hoisted_21, [
                    (_ctx.loadedData.productData)
                      ? (_openBlock(), _createElementBlock("a", _hoisted_22, "Info"))
                      : _createCommentVNode("", true),
                    (_ctx.loadedData.productImportLogs)
                      ? (_openBlock(), _createElementBlock("a", _hoisted_23, "Import Logs"))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.loadedData.orderData || _ctx.loadedData.orderItemsData)
                ? (_openBlock(), _createElementBlock("a", _hoisted_24, "Order"))
                : _createCommentVNode("", true),
              _createElementVNode("nav", _hoisted_25, [
                (_ctx.loadedData.orderData)
                  ? (_openBlock(), _createElementBlock("a", _hoisted_26, "Info / Shipments"))
                  : _createCommentVNode("", true),
                (_ctx.loadedData.orderItemsData)
                  ? (_openBlock(), _createElementBlock("a", _hoisted_27, "Items"))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.loadedData.bundleComponents || _ctx.loadedData.componentsBundles)
                ? (_openBlock(), _createElementBlock("a", _hoisted_28, "Bundles"))
                : _createCommentVNode("", true),
              (_ctx.loadedData.bundleComponents || _ctx.loadedData.componentsBundles)
                ? (_openBlock(), _createElementBlock("nav", _hoisted_29, [
                    (_ctx.loadedData.bundleComponents)
                      ? (_openBlock(), _createElementBlock("a", _hoisted_30, "Bundle Components"))
                      : _createCommentVNode("", true),
                    (_ctx.loadedData.componentsBundles)
                      ? (_openBlock(), _createElementBlock("a", _hoisted_31, "Components Bundles"))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.loadedData.notifications || _ctx.loadedData.stockLog)
                ? (_openBlock(), _createElementBlock("a", _hoisted_32, "Events"))
                : _createCommentVNode("", true),
              (_ctx.loadedData.notifications || _ctx.loadedData.stockLog)
                ? (_openBlock(), _createElementBlock("nav", _hoisted_33, [
                    (_ctx.loadedData.notifications)
                      ? (_openBlock(), _createElementBlock("a", _hoisted_34, "Notifications"))
                      : _createCommentVNode("", true),
                    (_ctx.loadedData.stockLog)
                      ? (_openBlock(), _createElementBlock("a", _hoisted_35, "Stock Log"))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_36, [
      _createElementVNode("div", _hoisted_37, [
        _createElementVNode("div", _hoisted_38, [
          _createElementVNode("div", _hoisted_39, [
            _hoisted_40,
            _createElementVNode("div", _hoisted_41, [
              (_ctx.isAnyData)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleClearResults())),
                    class: _normalizeClass(["btn btn-sm btn-danger d-flex justify-content-center align-items-center position-relative", [_ctx.clearResultsInProgress || _ctx.searchInProgress ? 'pointer-events-none cursor-default' : '']])
                  }, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["fw-bolder", [_ctx.clearResultsInProgress || _ctx.searchInProgress ? 'text-danger' : '']])
                    }, " CLEAR RESULTS ", 2),
                    (_ctx.clearResultsInProgress || _ctx.searchInProgress)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_42))
                      : _createCommentVNode("", true)
                  ], 2))
                : _createCommentVNode("", true),
              (_ctx.searchParams)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleClearSearch())),
                    class: _normalizeClass(["btn btn-sm btn-danger d-flex justify-content-center align-items-center position-relative", [_ctx.clearSearchInProgress || _ctx.searchInProgress ? 'pointer-events-none cursor-default' : '']])
                  }, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["fw-bolder", [_ctx.clearSearchInProgress || _ctx.searchInProgress ? 'text-danger' : '']])
                    }, " CLEAR SEARCH", 2),
                    (_ctx.clearSearchInProgress || _ctx.searchInProgress)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_43))
                      : _createCommentVNode("", true)
                  ], 2))
                : _createCommentVNode("", true),
              (_ctx.isAnyRequiredInfos() && _ctx.isAnyInfos())
                ? (_openBlock(), _createElementBlock("button", {
                    key: 2,
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleSearch())),
                    class: _normalizeClass(["btn btn-sm btn-success d-flex justify-content-center align-items-center position-relative", [_ctx.searchInProgress ? 'pointer-events-none cursor-default' : '']])
                  }, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["fw-bolder", [_ctx.searchInProgress ? 'text-success' : '']])
                    }, _toDisplayString(_ctx.isAnyData ? "UPDATE" : "GO"), 3),
                    (_ctx.searchInProgress)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_44))
                      : _createCommentVNode("", true)
                  ], 2))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("div", _hoisted_46, [
              _hoisted_47,
              _createElementVNode("div", _hoisted_48, [
                _createElementVNode("div", _hoisted_49, [
                  _createElementVNode("div", _hoisted_50, [
                    _createElementVNode("div", _hoisted_51, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.getters.account_info = $event)),
                        class: "form-check-input form-check-custom form-check-blue checkbox m-0 me-4",
                        type: "checkbox"
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.getters.account_info]
                      ]),
                      _createElementVNode("div", {
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.getSiteById())),
                        class: "me-2 cursor-pointer hover-underline"
                      }, "Account Info")
                    ]),
                    _createElementVNode("div", _hoisted_52, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.getters.integrations_info = $event)),
                        class: "form-check-input form-check-custom form-check-blue checkbox m-0 me-4",
                        type: "checkbox"
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.getters.integrations_info]
                      ]),
                      _createElementVNode("div", {
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.getMarketplaceCredentialsBySiteId())),
                        class: "me-2 cursor-pointer hover-underline"
                      }, " Integrations Info")
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_53, [
                    _createElementVNode("div", _hoisted_54, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.getters.product_info = $event)),
                        class: "form-check-input form-check-custom form-check-blue checkbox m-0 me-4",
                        type: "checkbox"
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.getters.product_info]
                      ]),
                      _createElementVNode("div", {
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.getMarketplaceProducts())),
                        class: "me-2 cursor-pointer hover-underline"
                      }, "Product Info ")
                    ]),
                    _createElementVNode("div", _hoisted_55, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.getters.product_import_log = $event)),
                        class: "form-check-input form-check-custom form-check-blue checkbox m-0 me-4",
                        type: "checkbox"
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.getters.product_import_log]
                      ]),
                      _createElementVNode("div", {
                        onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.getProductImportLogs())),
                        class: "me-2 cursor-pointer hover-underline"
                      }, "Product Import Logs ")
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_56, [
                    _createElementVNode("div", _hoisted_57, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.getters.order_info = $event)),
                        class: "form-check-input form-check-custom form-check-blue checkbox m-0 me-4",
                        type: "checkbox"
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.getters.order_info]
                      ]),
                      _createElementVNode("div", {
                        onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.getMarketplaceOrder())),
                        class: "me-2 cursor-pointer hover-underline"
                      }, " Order Info / Shipments ")
                    ]),
                    _createElementVNode("div", _hoisted_58, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.getters.order_items = $event)),
                        class: "form-check-input form-check-custom form-check-blue checkbox m-0 me-4",
                        type: "checkbox"
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.getters.order_items]
                      ]),
                      _createElementVNode("div", {
                        onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.getMarketplaceOrderItems())),
                        class: "me-2 cursor-pointer hover-underline"
                      }, "Order Items ")
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_59, [
                    _createElementVNode("div", _hoisted_60, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.getters.bundle_components = $event)),
                        class: "form-check-input form-check-custom form-check-blue checkbox m-0 me-4",
                        type: "checkbox"
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.getters.bundle_components]
                      ]),
                      _createElementVNode("div", {
                        onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.getBundleComponents())),
                        class: "me-2 cursor-pointer hover-underline"
                      }, " Bundle Components")
                    ]),
                    _createElementVNode("div", _hoisted_61, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.getters.components_bundles = $event)),
                        class: "form-check-input form-check-custom form-check-blue checkbox m-0 me-4",
                        type: "checkbox"
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.getters.components_bundles]
                      ]),
                      _createElementVNode("div", {
                        onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.getComponentsBundles())),
                        class: "me-2 cursor-pointer hover-underline"
                      }, "Components Bundles")
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_62, [
                    _createElementVNode("div", _hoisted_63, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.getters.notifications = $event)),
                        class: "form-check-input form-check-custom form-check-blue checkbox m-0 me-4",
                        type: "checkbox"
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.getters.notifications]
                      ]),
                      _createElementVNode("div", {
                        onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.getNotifications())),
                        class: "me-2 cursor-pointer hover-underline"
                      }, " Notifications")
                    ]),
                    _createElementVNode("div", _hoisted_64, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_ctx.getters.stock_log = $event)),
                        class: "form-check-input form-check-custom form-check-blue checkbox m-0 me-4",
                        type: "checkbox"
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.getters.stock_log]
                      ]),
                      _createElementVNode("div", {
                        onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.getStockLog())),
                        class: "me-2 cursor-pointer hover-underline"
                      }, "Stock Log")
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_65, [
              _hoisted_66,
              _createElementVNode("div", _hoisted_67, [
                _createElementVNode("form", {
                  onSubmit: _cache[33] || (_cache[33] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSearch && _ctx.handleSearch(...args)), ["prevent"])),
                  class: "data-container d-flex gap-7 rounded"
                }, [
                  (!_ctx.isAnyRequiredInfos())
                    ? (_openBlock(), _createElementBlock("h1", _hoisted_68, " Please select at least one search query! "))
                    : _createCommentVNode("", true),
                  (_ctx.requiredInfos.date_range)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                        _createVNode(_component_Datepicker, {
                          class: "h-100",
                          modelValue: _ctx.infos.date_range[0],
                          "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (_ctx.infos.date_range[0] = $event)),
                          enableTimePicker: false,
                          multiCalendars: false,
                          altPosition: "",
                          position: "center",
                          autoPosition: true,
                          multiCalendarsSolo: "",
                          selectText: "SAVE",
                          cancelText: "",
                          minDate: new Date('2000-01-01T00:00:00'),
                          maxDate: new Date(),
                          "prevent-min-max-navigation": true,
                          format: _ctx.datePickerFormatFrom,
                          state: _ctx.infos.date_range[0] !== null,
                          placeholder: "From Date",
                          "year-range": [2000, new Date().getFullYear()],
                          clearable: true
                        }, null, 8, ["modelValue", "minDate", "maxDate", "format", "state", "year-range"])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.requiredInfos.date_range)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                        _createVNode(_component_Datepicker, {
                          class: "h-100",
                          modelValue: _ctx.infos.date_range[1],
                          "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (_ctx.infos.date_range[1] = $event)),
                          enableTimePicker: false,
                          multiCalendars: false,
                          altPosition: "",
                          position: "center",
                          autoPosition: true,
                          multiCalendarsSolo: "",
                          selectText: "SAVE",
                          cancelText: "",
                          minDate: new Date('2000-01-01T00:00:00'),
                          maxDate: new Date(),
                          "prevent-min-max-navigation": true,
                          format: _ctx.datePickerFormatTo,
                          state: _ctx.infos.date_range[1] !== null,
                          placeholder: "To Date",
                          "year-range": [2000, new Date().getFullYear()],
                          clearable: true
                        }, null, 8, ["modelValue", "minDate", "maxDate", "format", "state", "year-range"])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.requiredInfos.site_id)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => (_ctx.infos.site_id = $event)),
                          type: "text",
                          pattern: "^[1-9]{1}[0-9]{0,23}$",
                          class: "form-control bg-white",
                          id: "fiSiteId",
                          placeholder: "Site ID"
                        }, null, 512), [
                          [_vModelText, _ctx.infos.site_id]
                        ]),
                        _hoisted_72
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.requiredInfos.marketplace_id)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => (_ctx.infos.marketplace_id = $event)),
                          type: "text",
                          class: "form-control bg-white",
                          id: "fiMarketplaceId",
                          placeholder: "Marketplace ID"
                        }, null, 512), [
                          [_vModelText, _ctx.infos.marketplace_id]
                        ]),
                        _hoisted_74
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.requiredInfos.system_product_id)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => (_ctx.infos.system_product_id = $event)),
                          type: "text",
                          class: "form-control bg-white",
                          id: "fiSysProdId",
                          placeholder: "System Product ID"
                        }, null, 512), [
                          [_vModelText, _ctx.infos.system_product_id]
                        ]),
                        _hoisted_76
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.requiredInfos.marketplace_product_id)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => (_ctx.infos.marketplace_product_id = $event)),
                          type: "text",
                          class: "form-control bg-white",
                          id: "fiMarkProdId",
                          placeholder: "Marketplace Product ID"
                        }, null, 512), [
                          [_vModelText, _ctx.infos.marketplace_product_id]
                        ]),
                        _hoisted_78
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.requiredInfos.product_SKU)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => (_ctx.infos.product_SKU = $event)),
                          type: "text",
                          class: "form-control bg-white",
                          id: "fiProdSKU",
                          placeholder: "Product SKU"
                        }, null, 512), [
                          [_vModelText, _ctx.infos.product_SKU]
                        ]),
                        _hoisted_80
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.requiredInfos.order_number)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => (_ctx.infos.order_number = $event)),
                          type: "text",
                          class: "form-control bg-white",
                          id: "fiOrderNum",
                          placeholder: "Order Number"
                        }, null, 512), [
                          [_vModelText, _ctx.infos.order_number]
                        ]),
                        _hoisted_82
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.requiredInfos.order_id)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => (_ctx.infos.order_id = $event)),
                          type: "text",
                          class: "form-control bg-white",
                          id: "fiOrderId",
                          placeholder: "Order ID"
                        }, null, 512), [
                          [_vModelText, _ctx.infos.order_id]
                        ]),
                        _hoisted_84
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.requiredInfos.search_keyword)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_85, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => (_ctx.infos.search_keyword = $event)),
                          type: "text",
                          class: "form-control bg-white",
                          id: "fiSearchKeyword",
                          placeholder: "Search Keyword"
                        }, null, 512), [
                          [_vModelText, _ctx.infos.search_keyword]
                        ]),
                        _hoisted_86
                      ]))
                    : _createCommentVNode("", true)
                ], 32)
              ])
            ]),
            (_ctx.queryErrors.length !== 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_87, [
                  _hoisted_88,
                  _createElementVNode("div", _hoisted_89, [
                    _createVNode(_component_SupportToolTable, {
                      tableData: _ctx.queryErrors,
                      dataModal: _ctx.dataModal
                    }, null, 8, ["tableData", "dataModal"])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      (_ctx.loadedData.accountData)
        ? (_openBlock(), _createElementBlock("div", _hoisted_90, [
            _createElementVNode("div", _hoisted_91, [
              _hoisted_92,
              _createElementVNode("div", _hoisted_93, [
                _createElementVNode("div", _hoisted_94, [
                  _hoisted_95,
                  _createElementVNode("div", _hoisted_96, [
                    _createVNode(_component_SupportToolTable, {
                      tableData: _ctx.loadedData.accountData,
                      dataModal: _ctx.dataModal
                    }, null, 8, ["tableData", "dataModal"])
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.loadedData.integrationsData)
        ? (_openBlock(), _createElementBlock("div", _hoisted_97, [
            _createElementVNode("div", _hoisted_98, [
              _hoisted_99,
              _createElementVNode("div", _hoisted_100, [
                _createElementVNode("div", _hoisted_101, [
                  _hoisted_102,
                  _createElementVNode("div", _hoisted_103, [
                    _createVNode(_component_SupportToolTable, {
                      tableData: _ctx.loadedData.integrationsData,
                      dataModal: _ctx.dataModal
                    }, null, 8, ["tableData", "dataModal"])
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.loadedData.productData || _ctx.loadedData.productImportLogs)
        ? (_openBlock(), _createElementBlock("div", _hoisted_104, [
            _createElementVNode("div", _hoisted_105, [
              _hoisted_106,
              _createElementVNode("div", _hoisted_107, [
                (_ctx.loadedData.productData)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_108, [
                      _hoisted_109,
                      _createElementVNode("div", _hoisted_110, [
                        _createVNode(_component_SupportToolTable, {
                          tableData: _ctx.loadedData.productData,
                          dataModal: _ctx.dataModal
                        }, null, 8, ["tableData", "dataModal"])
                      ]),
                      _createElementVNode("div", _hoisted_111, [
                        _createElementVNode("ul", _hoisted_112, [
                          _createElementVNode("li", _hoisted_113, [
                            _createElementVNode("div", {
                              onClick: _cache[34] || (_cache[34] = ($event: any) => (_ctx.getMarketplaceProducts(_ctx.productDataCursors[_ctx.getPreviousPageCursor(_ctx.productDataPage, _ctx.setProductDataPage)]))),
                              class: "page-link"
                            }, _hoisted_115)
                          ]),
                          _createElementVNode("li", _hoisted_116, [
                            _createElementVNode("a", _hoisted_117, _toDisplayString(`${_ctx.productDataPage + 1}`), 1)
                          ]),
                          _createElementVNode("li", _hoisted_118, [
                            _createElementVNode("div", {
                              onClick: _cache[35] || (_cache[35] = ($event: any) => (_ctx.getMarketplaceProducts(_ctx.productDataCursors[_ctx.getNextPageCursor(_ctx.productDataPage, _ctx.productDataCursors, _ctx.setProductDataPage)]))),
                              class: "page-link"
                            }, _hoisted_120)
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.loadedData.productImportLogs)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_121, [
                      _hoisted_122,
                      _createElementVNode("div", _hoisted_123, [
                        _createVNode(_component_SupportToolTable, {
                          tableData: _ctx.loadedData.productImportLogs,
                          dataModal: _ctx.dataModal
                        }, null, 8, ["tableData", "dataModal"])
                      ]),
                      _createElementVNode("div", _hoisted_124, [
                        _createElementVNode("ul", _hoisted_125, [
                          _createElementVNode("li", _hoisted_126, [
                            _createElementVNode("div", {
                              onClick: _cache[36] || (_cache[36] = ($event: any) => (_ctx.getProductImportLogs(_ctx.productImportLogsCursors[_ctx.getPreviousPageCursor(_ctx.productImportLogsPage, _ctx.setProductImportLogsPage)]))),
                              class: "page-link"
                            }, _hoisted_128)
                          ]),
                          _createElementVNode("li", _hoisted_129, [
                            _createElementVNode("a", _hoisted_130, _toDisplayString(`${_ctx.productImportLogsPage + 1}`), 1)
                          ]),
                          _createElementVNode("li", _hoisted_131, [
                            _createElementVNode("div", {
                              onClick: _cache[37] || (_cache[37] = ($event: any) => (_ctx.getProductImportLogs(_ctx.productImportLogsCursors[_ctx.getNextPageCursor(_ctx.productImportLogsPage, _ctx.productImportLogsCursors, _ctx.setProductImportLogsPage)]))),
                              class: "page-link"
                            }, _hoisted_133)
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.loadedData.orderData || _ctx.loadedData.orderItemsData)
        ? (_openBlock(), _createElementBlock("div", _hoisted_134, [
            _createElementVNode("div", _hoisted_135, [
              _hoisted_136,
              _createElementVNode("div", _hoisted_137, [
                (_ctx.loadedData.orderData)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_138, [
                      _hoisted_139,
                      _createElementVNode("div", _hoisted_140, [
                        _createVNode(_component_SupportToolTable, {
                          tableData: _ctx.loadedData.orderData,
                          dataModal: _ctx.dataModal
                        }, null, 8, ["tableData", "dataModal"])
                      ]),
                      _createElementVNode("div", _hoisted_141, [
                        _createElementVNode("ul", _hoisted_142, [
                          _createElementVNode("li", _hoisted_143, [
                            _createElementVNode("div", {
                              onClick: _cache[38] || (_cache[38] = ($event: any) => (_ctx.getMarketplaceOrder(_ctx.orderDataCursors[_ctx.getPreviousPageCursor(_ctx.orderDataPage, _ctx.setOrderDataPage)]))),
                              class: "page-link"
                            }, _hoisted_145)
                          ]),
                          _createElementVNode("li", _hoisted_146, [
                            _createElementVNode("a", _hoisted_147, _toDisplayString(`${_ctx.orderDataPage + 1}`), 1)
                          ]),
                          _createElementVNode("li", _hoisted_148, [
                            _createElementVNode("div", {
                              onClick: _cache[39] || (_cache[39] = ($event: any) => (_ctx.getMarketplaceOrder(_ctx.orderDataCursors[_ctx.getNextPageCursor(_ctx.orderDataPage, _ctx.orderDataCursors, _ctx.setOrderDataPage)]))),
                              class: "page-link"
                            }, _hoisted_150)
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.loadedData.orderItemsData)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_151, [
                      _hoisted_152,
                      _createElementVNode("div", _hoisted_153, [
                        _createVNode(_component_SupportToolTable, {
                          tableData: _ctx.loadedData.orderItemsData,
                          dataModal: _ctx.dataModal
                        }, null, 8, ["tableData", "dataModal"])
                      ]),
                      _createElementVNode("div", _hoisted_154, [
                        _createElementVNode("ul", _hoisted_155, [
                          _createElementVNode("li", _hoisted_156, [
                            _createElementVNode("div", {
                              onClick: _cache[40] || (_cache[40] = ($event: any) => (_ctx.getMarketplaceOrderItems(_ctx.orderItemsDataCursors[_ctx.getPreviousPageCursor(_ctx.orderItemsDataPage, _ctx.setOrderItemsDataPage)]))),
                              class: "page-link"
                            }, _hoisted_158)
                          ]),
                          _createElementVNode("li", _hoisted_159, [
                            _createElementVNode("a", _hoisted_160, _toDisplayString(`${_ctx.orderItemsDataPage + 1}`), 1)
                          ]),
                          _createElementVNode("li", _hoisted_161, [
                            _createElementVNode("div", {
                              onClick: _cache[41] || (_cache[41] = ($event: any) => (_ctx.getMarketplaceOrderItems(_ctx.orderItemsDataCursors[_ctx.getNextPageCursor(_ctx.orderItemsDataPage, _ctx.orderItemsDataCursors, _ctx.setOrderItemsDataPage)]))),
                              class: "page-link"
                            }, _hoisted_163)
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.loadedData.bundleComponents || _ctx.loadedData.componentsBundles)
        ? (_openBlock(), _createElementBlock("div", _hoisted_164, [
            _createElementVNode("div", _hoisted_165, [
              _hoisted_166,
              _createElementVNode("div", _hoisted_167, [
                (_ctx.loadedData.bundleComponents)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_168, [
                      _hoisted_169,
                      _createElementVNode("div", _hoisted_170, [
                        _createVNode(_component_SupportToolTable, {
                          tableData: _ctx.loadedData.bundleComponents,
                          dataModal: _ctx.dataModal
                        }, null, 8, ["tableData", "dataModal"])
                      ]),
                      _createElementVNode("div", _hoisted_171, [
                        _createElementVNode("ul", _hoisted_172, [
                          _createElementVNode("li", _hoisted_173, [
                            _createElementVNode("div", {
                              onClick: _cache[42] || (_cache[42] = ($event: any) => (_ctx.getBundleComponents(_ctx.bundleComponentsCursors[_ctx.getPreviousPageCursor(_ctx.bundleComponentsPage, _ctx.setBundleComponentsPage)]))),
                              class: "page-link"
                            }, _hoisted_175)
                          ]),
                          _createElementVNode("li", _hoisted_176, [
                            _createElementVNode("a", _hoisted_177, _toDisplayString(`${_ctx.bundleComponentsPage + 1}`), 1)
                          ]),
                          _createElementVNode("li", _hoisted_178, [
                            _createElementVNode("div", {
                              onClick: _cache[43] || (_cache[43] = ($event: any) => (_ctx.getBundleComponents(_ctx.bundleComponentsCursors[_ctx.getNextPageCursor(_ctx.bundleComponentsPage, _ctx.bundleComponentsCursors, _ctx.setBundleComponentsPage)]))),
                              class: "page-link"
                            }, _hoisted_180)
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.loadedData.componentsBundles)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_181, [
                      _hoisted_182,
                      _createElementVNode("div", _hoisted_183, [
                        _createVNode(_component_SupportToolTable, {
                          tableData: _ctx.loadedData.componentsBundles,
                          dataModal: _ctx.dataModal
                        }, null, 8, ["tableData", "dataModal"])
                      ]),
                      _createElementVNode("div", _hoisted_184, [
                        _createElementVNode("ul", _hoisted_185, [
                          _createElementVNode("li", _hoisted_186, [
                            _createElementVNode("div", {
                              onClick: _cache[44] || (_cache[44] = ($event: any) => (_ctx.getComponentsBundles(_ctx.componentsBundlesCursors[_ctx.getPreviousPageCursor(_ctx.componentsBundlesPage, _ctx.setComponentsBundlesPage)]))),
                              class: "page-link"
                            }, _hoisted_188)
                          ]),
                          _createElementVNode("li", _hoisted_189, [
                            _createElementVNode("a", _hoisted_190, _toDisplayString(`${_ctx.componentsBundlesPage + 1}`), 1)
                          ]),
                          _createElementVNode("li", _hoisted_191, [
                            _createElementVNode("div", {
                              onClick: _cache[45] || (_cache[45] = ($event: any) => (_ctx.getComponentsBundles(_ctx.componentsBundlesCursors[_ctx.getNextPageCursor(_ctx.componentsBundlesPage, _ctx.componentsBundlesCursors, _ctx.setComponentsBundlesPage)]))),
                              class: "page-link"
                            }, _hoisted_193)
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.loadedData.notifications || _ctx.loadedData.stockLog)
        ? (_openBlock(), _createElementBlock("div", _hoisted_194, [
            _createElementVNode("div", _hoisted_195, [
              _hoisted_196,
              _createElementVNode("div", _hoisted_197, [
                (_ctx.loadedData.notifications)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_198, [
                      _hoisted_199,
                      _createElementVNode("div", _hoisted_200, [
                        _createVNode(_component_SupportToolTable, {
                          tableData: _ctx.loadedData.notifications,
                          dataModal: _ctx.dataModal
                        }, null, 8, ["tableData", "dataModal"])
                      ]),
                      _createElementVNode("div", _hoisted_201, [
                        _createElementVNode("ul", _hoisted_202, [
                          _createElementVNode("li", _hoisted_203, [
                            _createElementVNode("div", {
                              onClick: _cache[46] || (_cache[46] = ($event: any) => (_ctx.getNotifications(_ctx.notificationsCursors[_ctx.getPreviousPageCursor(_ctx.notificationsPage, _ctx.setNotificationsPage)]))),
                              class: "page-link"
                            }, _hoisted_205)
                          ]),
                          _createElementVNode("li", _hoisted_206, [
                            _createElementVNode("a", _hoisted_207, _toDisplayString(`${_ctx.notificationsPage + 1}`), 1)
                          ]),
                          _createElementVNode("li", _hoisted_208, [
                            _createElementVNode("div", {
                              onClick: _cache[47] || (_cache[47] = ($event: any) => (_ctx.getNotifications(_ctx.notificationsCursors[_ctx.getNextPageCursor(_ctx.notificationsPage, _ctx.notificationsCursors, _ctx.setNotificationsPage)]))),
                              class: "page-link"
                            }, _hoisted_210)
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.loadedData.stockLog)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_211, [
                      _hoisted_212,
                      _createElementVNode("div", _hoisted_213, [
                        _createVNode(_component_SupportToolTable, {
                          tableData: _ctx.loadedData.stockLog,
                          dataModal: _ctx.dataModal
                        }, null, 8, ["tableData", "dataModal"])
                      ]),
                      _createElementVNode("div", _hoisted_214, [
                        _createElementVNode("ul", _hoisted_215, [
                          _createElementVNode("li", _hoisted_216, [
                            _createElementVNode("div", {
                              onClick: _cache[48] || (_cache[48] = ($event: any) => (_ctx.getStockLog(_ctx.stockLogCursors[_ctx.getPreviousPageCursor(_ctx.stockLogPage, _ctx.setStockLogPage)]))),
                              class: "page-link"
                            }, _hoisted_218)
                          ]),
                          _createElementVNode("li", _hoisted_219, [
                            _createElementVNode("a", _hoisted_220, _toDisplayString(`${_ctx.stockLogPage + 1}`), 1)
                          ]),
                          _createElementVNode("li", _hoisted_221, [
                            _createElementVNode("div", {
                              onClick: _cache[49] || (_cache[49] = ($event: any) => (_ctx.getStockLog(_ctx.stockLogCursors[_ctx.getNextPageCursor(_ctx.stockLogPage, _ctx.stockLogCursors, _ctx.setStockLogPage)]))),
                              class: "page-link"
                            }, _hoisted_223)
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}